import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M764.385882,112.941176 L990.268235,451.764706 L225.882353,451.764706 L225.882353,564.705882 L1920,564.705882 L1920,1637.64706 C1920,1731.04941 1843.99059,1807.05882 1750.58824,1807.05882 L1750.58824,1807.05882 L169.411765,1807.05882 C76.0094118,1807.05882 0,1731.04941 0,1637.64706 L0,1637.64706 L0,112.941176 L764.385882,112.941176 Z M1040,858.845726 L880,858.845726 L880,1098.84573 L640,1098.84573 L640,1258.84573 L880,1258.84573 L880,1498.84573 L1040,1498.84573 L1040,1258.84573 L1280,1258.84573 L1280,1098.84573 L1040,1098.84573 L1040,858.845726 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAddFolderSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAddFolderSolid, _Component);

  var _super = _createSuper(IconAddFolderSolid);

  function IconAddFolderSolid() {
    _classCallCheck(this, IconAddFolderSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAddFolderSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAddFolder",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAddFolderSolid.displayName = "IconAddFolderSolid";
  return IconAddFolderSolid;
}(Component);

IconAddFolderSolid.glyphName = 'add-folder';
IconAddFolderSolid.variant = 'Solid';
IconAddFolderSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAddFolderSolid;
export { IconAddFolderSolid };